
import { SIGNATURE_COLLECTION, LUXE_COLLECTION } from "@/utils/shopify";
import ProductMapMixin from "~/mixin/product-map-mixin";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
export default {
  name: "cal-subs-collection",
  props: {
    subsCMSData: {
      type: Object,
      required: true
    },
    isOngoing: {
      type: Boolean,
      required: true
    },
    isShowLuxeCollection:{
      type: Boolean,
      default:true
    }
  },
  watch: {
    "isSigActive"(){
      this.validateState()
    },
    "isLuxeActive"(){
      this.validateState()
    }
  },
  data() {
    return {
      subsAddons: [] as any[],
      showModal: false,
      showGreets: false,
      sigType: {
        id: SIGNATURE_COLLECTION
      },
      luxeType: {
        id: LUXE_COLLECTION
      },
      currCollection: this.$store.state.cartItem.selectedSubscription.collectionType,
      isSigActive: this.$store.state.cartItem.selectedSubscription.collectionType == SIGNATURE_COLLECTION,
      isLuxeActive: this.$store.state.cartItem.selectedSubscription.collectionType == LUXE_COLLECTION
    };
  },
  computed: {
    product(): any {
      return this.$store.state.cartItem.subscriptionProd;
    },
    selectedCollection(): any {
      return [{addon: {id: this.currCollection}}]
    }
  },
  mixins: [ProductMapMixin, DeliveryWeekMixin],
  methods: {
    toggleEvent(event: any) {
      if (event.addon.id == SIGNATURE_COLLECTION) {
        this.isSigActive = !this.isSigActive;
        this.isLuxeActive = false;
      } else {
        this.isLuxeActive = !this.isLuxeActive;
        this.isSigActive = false;
      }
      this.isLuxeActive || this.isSigActive ? this.$store.dispatch("cartItem/SUB_COLLECTION_SET", event.addon.id) : this.$store.dispatch("cartItem/SUB_COLLECTION_RESET");
      this.$nuxt.$emit("subVariantReset");
    },
    isObjectNotEmpty(obj: any) {
      return Object.keys(obj).length > 0;
    },
    validateState(){
      if(this.isSigActive || this.isLuxeActive){
        this.$nuxt.$emit("subsCollectionDisabled", false);
      }else{
        this.$nuxt.$emit("subsCollectionDisabled", true);
      }
    }
  },
  created() {
    this.validateState();
    this.$store.dispatch("cartItem/SUB_COLLECTION_RESET");

    this.$nuxt.$on("scrollToSubsCollection", () => {
      const SubsCollectionEl = document.getElementById('subs-collection');
      if (SubsCollectionEl) {
        SubsCollectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  },
};
